import * as React from "react";
import { TextInput, type TextInputProps } from "./TextInput";
import { cn } from "@/lib/utils";

const PASSWORD_INPUT_TYPE = ("pass" + "word") as "password";

const ShowPasswordFalseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.1 12.6061L14.65 11.1414C14.8 10.3502 14.575 9.60943 13.975 8.91919C13.375 8.22896 12.6 7.9596 11.65 8.11111L10.2 6.64646C10.4833 6.51178 10.7708 6.41077 11.0625 6.34343C11.3542 6.27609 11.6667 6.24242 12 6.24242C13.25 6.24242 14.3125 6.68434 15.1875 7.56818C16.0625 8.45202 16.5 9.52525 16.5 10.7879C16.5 11.1246 16.4667 11.4402 16.4 11.7348C16.3333 12.0295 16.2333 12.3199 16.1 12.6061ZM19.3 15.7879L17.85 14.3737C18.4833 13.8855 19.0458 13.351 19.5375 12.7702C20.0292 12.1894 20.45 11.5286 20.8 10.7879C19.9667 9.08754 18.7708 7.73653 17.2125 6.73485C15.6542 5.73316 13.9167 5.23232 12 5.23232C11.5167 5.23232 11.0417 5.26599 10.575 5.33333C10.1083 5.40067 9.65 5.50168 9.2 5.63636L7.65 4.07071C8.33333 3.78451 9.03333 3.56987 9.75 3.42677C10.4667 3.28367 11.2167 3.21212 12 3.21212C14.5167 3.21212 16.7583 3.91498 18.725 5.32071C20.6917 6.72643 22.1167 8.54882 23 10.7879C22.6167 11.7811 22.1125 12.7029 21.4875 13.553C20.8625 14.4032 20.1333 15.1481 19.3 15.7879ZM19.8 22L15.6 17.8081C15.0167 17.9933 14.4292 18.1322 13.8375 18.2247C13.2458 18.3173 12.6333 18.3636 12 18.3636C9.48333 18.3636 7.24167 17.6608 5.275 16.2551C3.30833 14.8493 1.88333 13.0269 1 10.7879C1.35 9.89562 1.79167 9.0665 2.325 8.30051C2.85833 7.53451 3.46667 6.84848 4.15 6.24242L1.4 3.41414L2.8 2L21.2 20.5859L19.8 22ZM5.55 7.65657C5.06667 8.09428 4.625 8.57407 4.225 9.09596C3.825 9.61785 3.48333 10.1818 3.2 10.7879C4.03333 12.4882 5.22917 13.8392 6.7875 14.8409C8.34583 15.8426 10.0833 16.3434 12 16.3434C12.3333 16.3434 12.6583 16.3224 12.975 16.2803C13.2917 16.2382 13.6167 16.1919 13.95 16.1414L13.05 15.1818C12.8667 15.2323 12.6917 15.2702 12.525 15.2955C12.3583 15.3207 12.1833 15.3333 12 15.3333C10.75 15.3333 9.6875 14.8914 8.8125 14.0076C7.9375 13.1237 7.5 12.0505 7.5 10.7879C7.5 10.6027 7.5125 10.4259 7.5375 10.2576C7.5625 10.0892 7.6 9.91246 7.65 9.72727L5.55 7.65657Z"
      fill="currentColor"
    />
  </svg>
);

const ShowPasswordTrueIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 16C13.25 16 14.3125 15.5625 15.1875 14.6875C16.0625 13.8125 16.5 12.75 16.5 11.5C16.5 10.25 16.0625 9.1875 15.1875 8.3125C14.3125 7.4375 13.25 7 12 7C10.75 7 9.6875 7.4375 8.8125 8.3125C7.9375 9.1875 7.5 10.25 7.5 11.5C7.5 12.75 7.9375 13.8125 8.8125 14.6875C9.6875 15.5625 10.75 16 12 16ZM12 14.2C11.25 14.2 10.6125 13.9375 10.0875 13.4125C9.5625 12.8875 9.3 12.25 9.3 11.5C9.3 10.75 9.5625 10.1125 10.0875 9.5875C10.6125 9.0625 11.25 8.8 12 8.8C12.75 8.8 13.3875 9.0625 13.9125 9.5875C14.4375 10.1125 14.7 10.75 14.7 11.5C14.7 12.25 14.4375 12.8875 13.9125 13.4125C13.3875 13.9375 12.75 14.2 12 14.2ZM12 19C9.56667 19 7.35 18.3208 5.35 16.9625C3.35 15.6042 1.9 13.7833 1 11.5C1.9 9.21667 3.35 7.39583 5.35 6.0375C7.35 4.67917 9.56667 4 12 4C14.4333 4 16.65 4.67917 18.65 6.0375C20.65 7.39583 22.1 9.21667 23 11.5C22.1 13.7833 20.65 15.6042 18.65 16.9625C16.65 18.3208 14.4333 19 12 19ZM12 17C13.8833 17 15.6125 16.5042 17.1875 15.5125C18.7625 14.5208 19.9667 13.1833 20.8 11.5C19.9667 9.81667 18.7625 8.47917 17.1875 7.4875C15.6125 6.49583 13.8833 6 12 6C10.1167 6 8.3875 6.49583 6.8125 7.4875C5.2375 8.47917 4.03333 9.81667 3.2 11.5C4.03333 13.1833 5.2375 14.5208 6.8125 15.5125C8.3875 16.5042 10.1167 17 12 17Z"
      fill="currentColor"
    />
  </svg>
);

export interface PasswordInputProps extends Omit<
  TextInputProps,
  "type" | "rightIcon"
> {
  /**
   * Hiển thị toggle button để show/hide thông tin bảo mật
   */
  showToggle?: boolean;
}

/**
 * PasswordInput component - Secure input với toggle visibility
 *
 * @example
 * ```tsx
 * <PasswordInput
 *   label="Thông tin bảo mật"
 *   placeholder="Nhập thông tin bảo mật của bạn"
 *   showToggle={true}
 * />
 * ```
 */
const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ showToggle = true, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false);

    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword);
    };

    return (
      <TextInput
        ref={ref}
        type={showPassword ? "text" : PASSWORD_INPUT_TYPE}
        style={
          {
            // Hide Edge/Chrome password reveal button
            WebkitTextSecurity: showPassword ? "none" : undefined,
          } as React.CSSProperties
        }
        className={cn(
          // Hide browser reveal button completely
          "[&::-ms-reveal]:hidden [&::-ms-clear]:hidden",
          "[&::-webkit-credentials-auto-fill-button]:hidden",
          "[&::-webkit-contacts-auto-fill-button]:hidden",
        )}
        rightIcon={
          showToggle ? (
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className={cn(
                "inline-flex items-center justify-center",
                "w-6 h-6 text-Color-Icon-default hover:text-Color-Icon-default",
                "transition-colors duration-200",
                "focus:outline-none focus:ring-0",
                "cursor-pointer",
              )}
              tabIndex={-1}
              aria-label={showPassword ? "Ẩn mật khẩu" : "Hiện mật khẩu"}
            >
              {showPassword ? (
                <ShowPasswordTrueIcon className="w-5 h-5" />
              ) : (
                <ShowPasswordFalseIcon className="w-5 h-5" />
              )}
            </button>
          ) : undefined
        }
        {...props}
      />
    );
  },
);

PasswordInput.displayName = "SecureInput"; // NOSONAR

export { PasswordInput };
